import { useState } from "react";

import { PharmaStpFileModel } from "../../../../data-model/nycbsPharmaOrder";
import AppealSummaryTabBar from "../components/appealSummaryTabBar";
import CaseDetailsContent from "./caseDetailsContent";
import HistoryPane from "./historyPane";

enum CaseDetailsTab {
  DETAILS = "details",
  HISTORY = "history",
}

const TAB_CONFIG = [
  { id: CaseDetailsTab.DETAILS, label: "Case Details" },
  { id: CaseDetailsTab.HISTORY, label: "History" },
];

interface CaseDetailsPaneProps {
  data: PharmaStpFileModel;
}

/**
 * Left pane of the appeal summary modal. Shows the read-only case details for
 * the selected order, or the appeal history timeline from `pharmacy/appeal/detail`.
 *
 * @param props.data - Order row the modal was opened for
 */
const CaseDetailsPane = (props: CaseDetailsPaneProps) => {
  const [activeTab, setActiveTab] = useState<CaseDetailsTab>(
    CaseDetailsTab.DETAILS,
  );

  return (
    <div className="flex h-full min-h-0 flex-col">
      <AppealSummaryTabBar
        tabs={TAB_CONFIG}
        activeTabId={activeTab}
        onTabChange={(tabId) => setActiveTab(tabId as CaseDetailsTab)}
      />

      <div className="min-h-0 flex-1 overflow-y-auto">
        {activeTab === CaseDetailsTab.DETAILS && (
          <CaseDetailsContent data={props.data} />
        )}
        {activeTab === CaseDetailsTab.HISTORY && (
          <HistoryPane data={props.data} />
        )}
      </div>
    </div>
  );
};

export default CaseDetailsPane;
